export const responseType = [
  { label: "Correo", value: 0 },
  { label: "SMS", value: 1 },
  { label: "Correo y SMS", value: 2 },
];
export const streeNameList = [
  { label: "Calle", value: "Calle" },
  { label: "Carrera", value: "Carrera" },
  { label: "Transversal", value: "Transversal" },
  { label: "Diagonal", value: "Diagonal" },
  { label: "Avenida", value: "Avenida" },
];
export const bondList = [
  { label: "Padre", value: 0 },
  { label: "Madre", value: 1 },
  { label: "Tio (a)", value: 2 },
  { label: "Hermano (a)", value: 3 },
  { label: "Otro", value: 4 },
];
